import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { QUOTE_QUESTIONS } from "../../AppConstants";

const rules = {
    currentInsuranceCompany: 'required',
    currentInsuranceCompanyPeriod: 'required',
    currentBiLimits: 'required',
    currentInsuranceCompanyMonths: [
        { required_if: ['currentInsuranceCompanyPeriod', QUOTE_QUESTIONS.INSURANCE_HISTORY.CURRENT_INSURANCE_COMPANY_PERIOD.LESS_ONE_YEAR] }
    ]
};

export const allFieldsValidation = (data, stateCode: string | null = null) => {
    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};